import { css } from '@emotion/react';

export const containerStyles = css`
  max-width: 300px;
  margin: 0 auto;
`;

export const iconStyles = css`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 48px;
  height: 48px;
  border-radius: 50%;
  background-color: var(--color-primary-500);
  color: var(--color-base-white);
`;

export const badgeStyles = css`
  display: inline-flex;
  justify-content: center;
  align-items: center;
  font-size: 0.75rem;
  font-weight: 700;
  padding: var(--spacing-1) var(--spacing-4);
  border-radius: 7px;
  background-color: var(--color-yellow-500);
  color: var(--color-neutral-800);
`;
